/** This app open's evaluation has finished. The score clock is not compared. */
export function isOpenReady(response: { openReady?: boolean } | null | undefined): boolean {
  return response?.openReady === true;
}

export function hasUnknownEligibility(detail: { conditions?: Array<{ status?: string }> } | null | undefined): boolean {
  return Array.isArray(detail?.conditions) && detail.conditions.some((condition) => condition.status === 'unknown');
}
